import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../utils/api";
import { Megaphone, MapPin, FileText, Video, Image, type LucideIcon } from "lucide-react";

const STATUS_LABELS: Record<string, { label: string; color: string }> = {
  pending_payment: { label: "En attente de paiement", color: "#999" },
  active: { label: "Active", color: "#1D9E75" },
  completed: { label: "Terminée", color: "#666" },
  cancelled: { label: "Annulée", color: "#c0392b" },
};
const TARGET_LABELS: Record<string, string> = { venue: "Lieu", publication: "Publication", live: "Live", ad_creative: "Publicité" };
const TARGET_ICONS: Record<string, LucideIcon> = { venue: MapPin, publication: FileText, live: Video, ad_creative: Image };

export default function MySponsorships() {
  const navigate = useNavigate();
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/sponsorships/me").then(data => setItems(data?.sponsorships || [])).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const cancel = (id: string) => {
    if (!window.confirm("Annuler cette campagne avant paiement ?")) return;
    api.put(`/sponsorships/${id}/cancel`, {}).then(load).catch(() => {});
  };

  return (
    <div style={{ maxWidth: 640, margin: "0 auto", padding: "20px 20px 40px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}>
        <button onClick={() => navigate("/settings")} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 20, padding: 0 }}>←</button>
        <h1 style={{ fontSize: 20, fontWeight: 800, margin: 0 }}>Mes sponsorisations</h1>
      </div>

      {loading && <div style={{ textAlign: "center", padding: 60, color: "#999" }}>Chargement…</div>}

      {!loading && items.length === 0 && (
        <div style={{ textAlign: "center", padding: "60px 20px", color: "#999" }}>
          <Megaphone size={40} strokeWidth={1.5} color="#ccc" style={{ marginBottom: 12 }} />
          <div style={{ fontSize: 15, fontWeight: 600 }}>Aucune campagne pour le moment</div>
          <div style={{ fontSize: 13, marginTop: 6 }}>Booste un lieu, une publication ou un Live pour le mettre en avant.</div>
        </div>
      )}

      {items.map(s => {
        const status = STATUS_LABELS[s.status] || STATUS_LABELS.pending_payment;
        const TargetIcon = TARGET_ICONS[s.target_type];
        return (
          <div key={s.id} style={{ backgroundColor: "white", borderRadius: 16, padding: 18, marginBottom: 12, border: "1px solid #F0F0F0" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ width: 34, height: 34, borderRadius: 10, backgroundColor: "#F5F5F5", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <TargetIcon size={16} strokeWidth={1.75} color="#0a0a0a" />
                </div>
                <div>
                  <div style={{ fontSize: 11, fontWeight: 700, color: "#999", textTransform: "uppercase", letterSpacing: 0.5 }}>{TARGET_LABELS[s.target_type]}</div>
                  <div style={{ fontSize: 15, fontWeight: 700, marginTop: 2 }}>{s.target_label || "—"}</div>
                </div>
              </div>
              <span style={{ fontSize: 11, fontWeight: 700, color: status.color, backgroundColor: "#F5F5F5", borderRadius: 10, padding: "3px 9px" }}>{status.label}</span>
            </div>
            <div style={{ fontSize: 12.5, color: "#666", marginTop: 10 }}>
              {Number(s.budget_total).toFixed(2)} € · {s.duration_days} j
              {s.radius_km && ` · ${s.radius_km} km`}
              {(s.min_age || s.max_age) && ` · ${s.min_age || 16}-${s.max_age || 80} ans`}
              {s.gender !== "all" && ` · ${s.gender === "homme" ? "Hommes" : "Femmes"}`}
            </div>
            {s.status === "active" && s.ends_at && (
              <div style={{ fontSize: 12, color: "#999", marginTop: 4 }}>Jusqu'au {new Date(s.ends_at).toLocaleDateString("fr-FR")}</div>
            )}
            {s.status === "pending_payment" && (
              <button onClick={() => cancel(s.id)} style={{ marginTop: 10, fontSize: 12, fontWeight: 600, color: "#c0392b", background: "none", border: "none", cursor: "pointer", padding: 0 }}>
                Annuler
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}
